import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { useNavigate, useLocation } from "react-router-dom";
import HelpMessage from "./HelpMessage";
import axios from "axios";
import SearchBar from "./SearchBar";
import PopUp from "./PopUp";
const Results = () => {
  const navigate = useNavigate();

  const monthDataString = localStorage.getItem("currentCard");
  const volumeValue = localStorage.getItem("volumeValue");
  const parsedMonthData = JSON.parse(monthDataString);
  console.log('this is paras',parsedMonthData);
  const [userData, setUserData] = useState(null);
  const [detailsData, setDetailsData] = useState(null);
  const getMonthName = (monthNumber) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthNumber - 1];
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { userData } = await fetchAllData();
        setDetailsData(userData.resultProcedure.recordsets[1]);
        // setUserData(userData.supplierData||userData.userData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {}, [parsedMonthData]);

  const fetchAllData = async () => {
    try {
      const token = localStorage.getItem("token");
      const role = localStorage.getItem("role");
      const isAdmin = role && role.includes("admin");
      let endpoint = process.env.REACT_APP_API_BASEURL + "/api/Home/data/details/" + parsedMonthData.month + '-' + parsedMonthData.year;

      if (isAdmin && parsedMonthData.supplier) {
        const supplierId = parsedMonthData.supplier;
        endpoint = process.env.REACT_APP_API_BASEURL + `/api/Home/supplierdata/${supplierId}/details/${parsedMonthData.month}-${parsedMonthData.year}`;
      }

      const userDataResponse = await axios.get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const userData = userDataResponse.data;
      console.log("userdata", userData);
      return { userData };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  const [displayedColumns, setDisplayedColumns] = useState({
    day: true,
    vol: true,
    bf: true,
    prt: true,
    scc: true,
    bac: true,
    bse: true,
    fpd: true,
    ant: true,
    urea: true,
    syn: true,
    bcfu: true,
    sbcfu: true,
  });

  const columnsToDataMap = {
    day: "dayT",
    vol: "CollectedVol",
    bf: "BF",
    prt: "PRT",
    scc: "SCC",
    bac: "BAC",
    bse: "BSE",
    fpd: "FPD",
    ant: "ANT",
    urea: "UREA",
    syn: "SYN",
    bcfu: "BCFU",
    sbcfu: "SBCFU",
  };

  // Check if the user has previously clicked the "SCREEN OPTIONS" link
  const popupVisibility = localStorage.getItem("popupVisibility") === "true";

  const [popupStyle, setPopupStyle] = useState({
    visibility: popupVisibility ? "visible" : "hidden",
    opacity: popupVisibility ? 1 : 0,
  });

  const handleFilterApply = (updatedFilters) => {
    // Update displayed columns based on the updated filters from the Popup
    setDisplayedColumns(updatedFilters);

    // Hide the popup after applying filter
    setPopupStyle({
      visibility: "hidden",
      opacity: 0,
    });

    // Save the user's preference for the popup visibility
    localStorage.setItem("popupVisibility", "false");
  };

  const handleScreenOptionsClick = () => {
    // Show the popup for screen options
    setPopupStyle({
      visibility: "visible",
      opacity: 1,
    });

    // Save the user's preference for the popup visibility
    localStorage.setItem("popupVisibility", "true");
  };

  useEffect(() => {
    // Hide the popup when the component mounts
    setPopupStyle({
      visibility: "hidden",
      opacity: 0,
    });
  }, []);

  return (
    <>
      <div className="container-login100">
        <div className="wrap-login100">
          <Navbar />
          <div className="tableft">
            <a>Results</a>
          </div>
          <div className="" id="result-wrapper">
            <SearchBar />
            <form className="login100-form validate-form">
              <div className="home_page_single" id="result">
                <div className="tr date">
                  <div className="td" colSpan="4">
                    {getMonthName(parsedMonthData.month)} {parsedMonthData.year}
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td odd heading text-right">
                        VOLUME : {parsedMonthData.CollectedVol || 0}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td odd heading text-right">BF : </div>
                    <div className="td odd text-left">{parsedMonthData.BF}</div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">
                        PRT : {parsedMonthData.PRT}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td odd heading text-right">SCC :</div>

                    <div className="td odd text-left">
                      {parsedMonthData.SCC}
                    </div>
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">BAC : {parsedMonthData.BAC}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">BSE : {parsedMonthData.BSE}</div>

                    <div className="td text-left"></div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">
                        FPD : {parsedMonthData.FPD}
                      </div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">ANT : </div>

                    <div className="td text-left">{parsedMonthData.ANT}</div>
                  </div>
                </div>

                <div className="green custom_design tr">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">UREA : {parsedMonthData.UREA}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">SIGHT : 0</div>

                    <div className="td text-left"></div>
                  </div>
                </div>

                <div className="tr white custom_design">
                  <div className="custom-half">
                    <div className="display-option-wrap">
                      <div className="td heading text-right">BCFU : {parsedMonthData.BCFU}</div>
                    </div>
                  </div>

                  <div className="custom-half pl-50">
                    <div className="td heading text-right">SBCFU : {parsedMonthData.SBCFU}</div>
                    <div className="td text-left"></div>
                  </div>
                </div>
              </div>
            </form>
            <div
              id="view-statement"
              onClick={() => {
                navigate("/Statement/" + parsedMonthData.month + "-" + parsedMonthData.year);
              }}
            >
              <a>
                <i className="fas fa-edit pr-15" /> <span>SEE REPORT</span>
              </a>
            </div>
            <div id="resultsmaintable">
              <div id="display-options">
                <a onClick={handleScreenOptionsClick}>
                  <span aria-hidden="true" className="glyphicon glyphicon-th" />
                  SCREEN OPTIONS
                </a>
              </div>

              <div className="clearfix" />

              <div className="table-responsive">
                <table id="resultdetail">
                  <tbody>
                    <tr className="heading">
                      {Object.keys(displayedColumns)?.map(
                        (columnKey) =>
                          displayedColumns[columnKey] && (
                            <td key={columnKey} className={`fil-${columnKey}`}>
                              {columnKey.toUpperCase()}
                            </td>
                          )
                      )}
                    </tr>
                    {detailsData ? (
                      // userData
                        // .filter(
                        //   (data) =>
                        //     data.month === parsedMonthData.month &&
                        //     data.year === parsedMonthData.year
                        // )
                        detailsData.map((monthData, index) => (
                          <tr key={index}>
                            {Object.keys(displayedColumns).map(
                              (columnKey) =>
                                displayedColumns[columnKey] && (
                                  <td
                                    key={`${columnKey}-${index}`}
                                    className={`odd fil-${columnKey}`}
                                  >
                                    {monthData[ columnsToDataMap[columnKey] ]||0}
                                  </td>
                                )
                            )}
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="10">Loading user data...</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {popupVisibility && (
              <PopUp
                handleFilterApply={handleFilterApply}
                popupStyle={popupStyle}
              />
            )}
            <HelpMessage />
          </div>
        </div>
      </div>
    </>
  );
};

export default Results;
